(function() {
  const EC2_URL = 'https://apps.whisperinghomes.com';
  const CID = window.__st?.cid || null;
  const TEN_DAYS = 10 * 24 * 60 * 60 * 1000;

  // ─────────────────────────────────────────────
  // FREE GIFT HELPERS
  // Gift lines (cart-global ka free-gift logic `_gift_for` property ke saath
  // add karta hai) server par kabhi save/restore NAHI honi chahiye — warna
  // user ke delete kiye hue gift page load par wapas aa jaate hain.
  // ─────────────────────────────────────────────
  function isGiftLine(item) {
    return !!(item && item.properties && item.properties._gift_for);
  }

  // cart-global.liquid se aata hai (stable list of all gift variant ids)
  function getGiftPool() {
    return (window.__fgbAllGiftVariantIds || []).map(Number);
  }

  async function saveCartToServer() {
    if (!CID) return;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const items = cart.items
        .filter(item => !isGiftLine(item)) // gift lines save mat karo
        .map(item => ({
          id: item.variant_id,
          quantity: item.quantity,
          title: item.title,
          image: item.image,
          regular: true // paid line hai — restore karna safe hai
        }));
      await fetch(`${EC2_URL}/cart/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: CID, items, saved_at: Date.now() })
      });
    } catch(e) { console.warn('WH Cart: save failed', e); }
  }

  async function loadCartFromServer() {
    if (!CID) return;
    try {
      const res = await fetch(`${EC2_URL}/cart/get?customer_id=${CID}`);
      const data = await res.json();
      if (!data.success || !data.cart) return;

      // Check 10-day expiry
      if (data.cart.saved_at && (Date.now() - data.cart.saved_at) > TEN_DAYS) {
        await fetch(`${EC2_URL}/cart/save`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customer_id: CID, items: [], saved_at: Date.now() })
        });
        return;
      }

      const items = data.cart.items || [];
      if (!items.length) return;

      // Get current cart items to avoid duplicates
      const currentCart = await fetch('/cart.js').then(r => r.json());
      const currentIds = currentCart.items.map(i => i.variant_id);
      const giftPool = getGiftPool();

      // Only add items not already in cart, and NEVER restore free gifts.
      // Purane snapshots mein `regular` flag nahi hota — unme gift pool ke
      // variants skip karo (kyunki woh pehle gift ke roop mein save hue the).
      const filteredItems = items.filter(i => {
        if (currentIds.includes(i.id)) return false;
        if (isGiftLine(i)) return false;
        if (!i.regular && giftPool.includes(Number(i.id))) return false;
        return true;
      });
      if (!filteredItems.length) return;

      const outOfStock = [];

      for (const item of filteredItems) {
        try {
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.id, quantity: item.quantity })
          });
          const addData = await addRes.json();
          if (addData.status === 422 || !addData.id) {
            outOfStock.push(item.title || 'Item');
          }
        } catch(e) {
          outOfStock.push(item.title || 'Item');
        }
      }

      // Update cart count bubble
      const finalCart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => {
        el.textContent = finalCart.item_count;
      });

      // Re-render cart drawer with fresh section HTML
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && finalCart.item_count > 0) {
        cartDrawer.classList.remove('is-empty');
        const drawerInner = cartDrawer.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');

        const sectionsRes = await fetch(`/?sections=cart-drawer,cart-icon-bubble`)
          .then(r => r.json())
          .catch(() => null);

        if (sectionsRes) {
          const cartDrawerEl = document.getElementById('CartDrawer');
          if (cartDrawerEl && sectionsRes['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionsRes['cart-drawer'], 'text/html');
            const newDrawer = doc.querySelector('#CartDrawer');
            if (newDrawer) cartDrawerEl.innerHTML = newDrawer.innerHTML;
          }

          const cartIconEl = document.getElementById('cart-icon-bubble');
          if (cartIconEl && sectionsRes['cart-icon-bubble']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionsRes['cart-icon-bubble'], 'text/html');
            const newIcon = doc.querySelector('#cart-icon-bubble');
            if (newIcon) cartIconEl.innerHTML = newIcon.innerHTML;
          }
        }
      }

      // Notify user about out-of-stock items
      if (outOfStock.length) {
        showCartNotification(`These items are no longer available: ${outOfStock.join(', ')}`);
      }

    } catch(e) { console.warn('WH Cart: load failed', e); }
  }

  function showCartNotification(message) {
    const toast = document.createElement('div');
    toast.style.cssText = `
      position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
      background: var(--black-main-1); color: var(--white); padding: 14px 24px;
      border-radius: 8px; font-size: var(--font-size-price); z-index: 99999;
      max-width: 400px; text-align: center;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    `;
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 5000);
  }

  // Detect logout and clear local cart
  const wasLoggedIn = localStorage.getItem('wh_cart_logged_in');
  if (!CID && wasLoggedIn) {
    if (!window.location.pathname.includes('/checkout')) {
      fetch('/cart/clear.js', { method: 'POST' }).then(() => {
        // Reset cart count display
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => {
          el.textContent = '0';
        });
        document.querySelectorAll('.cart-count-bubble').forEach(el => {
          el.style.display = 'none';
        });
        // Set cart drawer to empty state
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('is-empty');
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.classList.add('is-empty');
        }
      });
    }
    localStorage.removeItem('wh_cart_logged_in');
  } else if (CID) {
    localStorage.setItem('wh_cart_logged_in', '1');
  }

  // Clear server cart after successful checkout
  if (window.location.pathname.includes('/thank_you') ||
      window.location.pathname.includes('/orders/')) {
    if (CID) {
      fetch(`${EC2_URL}/cart/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: CID, items: [], saved_at: Date.now() })
      });
    }
  }

  async function boot() {
    if (CID) {
      // Restore saved cart on login
      await loadCartFromServer();
      // Save merged cart result to server
      setTimeout(saveCartToServer, 2000);
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  // Intercept cart mutations to auto-save to server
  const _fetch = window.fetch;
  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : (input?.url || '');
    const method = (init?.method || 'GET').toUpperCase();
    if (
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
      && method === 'POST'
    ) {
      return _fetch.apply(this, arguments).then(res => {
        res.clone().json().then(() => {
          setTimeout(saveCartToServer, 1000);
        }).catch(() => {});
        return res;
      });
    }
    return _fetch.apply(this, arguments);
  };

  window.WHCartSync = { save: saveCartToServer, load: loadCartFromServer };
})();